<template>
    <data-hud class="data-hud" :title="title" unit="mmHg" :data="data"/>
</template>

<script>
import DataHud from "./data-hud.vue"
import { useI18n } from 'vue-i18n';

export default
  {
    name: 'blood-pressure',
    props: {
        data: String
    },
    setup() {
    const { t, locale } = useI18n()
    return {t, locale}
    },
    components: { DataHud },
    computed: {
        title() {
            const title = this.t('vital_signs.bloodPressure.title');
            return "*" + title.substring(0, title.length-7);
        }
    }
}
</script>

<style scoped>
.data-hud {
    position: relative;
}
@media (max-width: 1044px) {
    .data-hud {
        position: relative;
        right: auto;
        top: auto;
    }
}
</style>


